export default "__VITE_ASSET__Dt49OObV__"